export const USER_SEARCH_REQUEST = "USER_SEARCH_REQUEST"
export const USER_SEARCH_SUCCESS = "USER_SEARCH_SUCCESS"
export const USER_SEARCH_FAIL = "USER_SEARCH_FAIL"
